import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "../public/css/chassis.min.css";
import "valuations-journey/dist/index.css";
import { AppBaseUrl } from "./config/env";
import {
  Wrapper,
  Landing,
  RegInput,
  Mileage,
  Assumptions,
  FactualQuestionsCompactView,
  ConditionQuestionsCompactView,
  PhotosIntro,
  InitialOffer,
  ConditionAnswersReview,
  ImageUploadHelper,
  UploadProgress,
  PhotoGallery,
  Error,
  Unauthorised,
  ManualEnquiry,
  MileageOnly,
  MileageUploadProgress,
  MilageOnlyUpload,
  CheckRegistration,
  UnableToValueError,
  IneligibleVehicleError,
  VehicleVariant,
  BranchConfirmation,
  EstimatedOffer,
  CustomerConfirmation
} from "./pages";
import "./stylesheets/App.scss";
import ProtectedRoutes from "./components/ProtectedRoutes";
import { createProvider } from "./pages/ImageUploads/context/axiosContext";
import ReuseVehicle from "./pages/ReuseVehicle";
import AnswersReview from "./pages/AnswersReview";
import { Wheels } from "./pages/ConditionQuestions/pages/Wheels";
import { Mechanics } from "./pages/ConditionQuestions/pages/Mechanics";
import { Tyres } from "./pages/ConditionQuestions/pages/tyres";
import { Bodywork } from "./pages/ConditionQuestions/pages/Bodywork";
import { ServiceHistory } from "./pages/FactualQuestions/pages/ServiceHistory";
import { Keys } from "./pages/FactualQuestions/pages/Keys";
import { Taxi } from "./pages/FactualQuestions/pages/taxi";
import { Interior } from "./pages/ConditionQuestions/pages/Interior";
import {
  QuestionIds,
  questionRoutingLabels
} from "./data/QuestionPresentation";
import { CONFIRMATION_TYPES } from "./data/confirmationTypes";
import useAnalytics from "./hooks/useAnalytics";


const AxiosProvider = createProvider();

function App() {
  useAnalytics();
  return (
    <AxiosProvider>
      <Router basename={`${AppBaseUrl}`}>
        <Wrapper>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route
              path="/valuation-saved"
              element={
                <CustomerConfirmation
                  confirmationType={CONFIRMATION_TYPES.TRADE_IN}
                />
              }
            />
            <Route
              path="/valuation-email-sent"
              element={
                <CustomerConfirmation
                  confirmationType={CONFIRMATION_TYPES.EMAIL}
                />
              }
            />
            <Route path="/registration" element={<RegInput />} />
            <Route path="/reuse-vehicle/" element={<ReuseVehicle />} />
            <Route path="/mileage/" element={<Mileage />} />
            <Route path="/mileage-only/" element={<MileageOnly />} />
            <Route path="/answers-review/" element={<AnswersReview />} />
            <Route
              path="/assumptions"
              element={
                <ProtectedRoutes>
                  <Assumptions />
                </ProtectedRoutes>
              }
            />
            <Route
              path={`/${questionRoutingLabels[QuestionIds.TAXI]}`}
              element={
                <ProtectedRoutes>
                  <Taxi />
                </ProtectedRoutes>
              }
            />
            <Route
              path={`/${questionRoutingLabels[QuestionIds.KEYS]}`}
              element={
                <ProtectedRoutes>
                  <Keys />
                </ProtectedRoutes>
              }
            />
            <Route
              path={`/${questionRoutingLabels[QuestionIds.SERVICEHISTORY]}`}
              element={
                <ProtectedRoutes>
                  <ServiceHistory />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/branch/about"
              element={
                <ProtectedRoutes>
                  <FactualQuestionsCompactView />
                </ProtectedRoutes>
              }
            />
            <Route
              path={`/${questionRoutingLabels[QuestionIds.WHEELS]}`}
              element={
                <ProtectedRoutes>
                  <Wheels />
                </ProtectedRoutes>
              }
            />
            <Route
              path={`/${questionRoutingLabels[QuestionIds.MECHANICSELECTRICS]}`}
              element={
                <ProtectedRoutes>
                  <Mechanics />
                </ProtectedRoutes>
              }
            />
            <Route
              path={`/${questionRoutingLabels[QuestionIds.EXTERIORBODYWORK]}`}
              element={
                <ProtectedRoutes>
                  <Bodywork />
                </ProtectedRoutes>
              }
            />
            <Route
              path={`/${questionRoutingLabels[QuestionIds.TYRES]}`}
              element={
                <ProtectedRoutes>
                  <Tyres />
                </ProtectedRoutes>
              }
            />
            <Route
              path={`/${questionRoutingLabels[QuestionIds.INTERIOR]}`}
              element={
                <ProtectedRoutes>
                  <Interior />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/branch/condition"
              element={
                <ProtectedRoutes>
                  <ConditionQuestionsCompactView />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/initial-offer"
              element={
                <ProtectedRoutes>
                  <InitialOffer />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/photos-intro"
              element={
                <ProtectedRoutes>
                  <PhotosIntro />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/review-answers"
              element={
                <ProtectedRoutes>
                  <ConditionAnswersReview />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/image-upload/:id"
              element={
                <ProtectedRoutes>
                  <ImageUploadHelper />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/image-upload-milage-only"
              element={
                <ProtectedRoutes>
                  <MilageOnlyUpload />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/image-upload-progress/:id"
              element={
                <ProtectedRoutes>
                  <UploadProgress />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/milage-upload-progress"
              element={
                <ProtectedRoutes>
                  <MileageUploadProgress />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/photo-gallery"
              element={
                <ProtectedRoutes>
                  <PhotoGallery />
                </ProtectedRoutes>
              }
            />
            <Route
              path="/vehicle-variant"
              element={
                <ProtectedRoutes>
                  <VehicleVariant />
                </ProtectedRoutes>
              }
            />
            <Route path="/estimated-offer" element={<EstimatedOffer />} />
            <Route path="/manual-enquiry" element={<ManualEnquiry />} />
            <Route path="/error" element={<Error />} />
            <Route path="/check-registration" element={<CheckRegistration />} />
            <Route path="/unable-to-value" element={<UnableToValueError />} />
            <Route
              path="/ineligible-vehicle"
              element={<IneligibleVehicleError />}
            />
            <Route path="/unauthorised" element={<Unauthorised />} />
            <Route
              path="/branch-valuation-confirmation"
              element={<BranchConfirmation />}
            />
            <Route path="/wheels" element={<Wheels />} />
          </Routes>
        </Wrapper>
      </Router>
    </AxiosProvider>
  );
}

export default App;
